import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { HttpService } from '../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class VisualizarFuncionarioService {

  constructor(private http:HttpService) { }


  saveCadastrarUsuario(data: any, successHandle: Function, errorHandle:Function) {
    return this.http.doPost('/employee', data, successHandle, errorHandle);
  }

  updateCadastrarUsuario(data: any, successHandle: Function, errorHandle: Function) {
    return this.http.doPut('/employee', data, successHandle, errorHandle);
  }

  pesquisarUsuario(path:any, data: any, successHandle:Function, errorHandle:Function) {

    return this.http.doGet('/integrated/employee/'+path, data, successHandle, errorHandle);
  }

  pesquisaPessoaCpf(path:any, data: any, successHandle:Function, errorHandle:Function) {
    return this.http.doGet('/employee/'+path, data, successHandle, errorHandle);
  }

  validateRegistration(data: any, successHandle:Function, errorHandle:Function) {

    return this.http.doGet('/employee/validateRegistration', data, successHandle, errorHandle);
  }

  address(path:any, data: any, successHandle: Function, errorHandle: Function) {

    return this.http.doGet('/person/address/'+path, data, successHandle, errorHandle);

  }

  pesquisaPessoaCpfMatricula(cpf: string, matricula: string, successHandle: Function, errorHandle: Function) {
    return this.http.doGet(`/employee/${cpf}/${matricula}`, null, successHandle, errorHandle);
  }  
  
}
